
export default function Hero() {
  return (
    <section aria-label="Meta Ads Specialist – Hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f12ffe36d13036f0cc266f75ee9936ce.jpg"
          alt="Meta Ads management workspace – Facebook and Instagram campaign analytics"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/75 via-black/65 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 lg:px-8 py-40 text-center">
        <p className="text-teal-300 text-sm font-semibold uppercase tracking-widest mb-4">
          Meta Ads Specialist
        </p>
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          More sales from <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-300 to-pink-400">your Meta ads.</span>
        </h1>
        <p className="text-xl md:text-2xl text-white/85 font-light mb-10 leading-relaxed max-w-2xl mx-auto">
          Expert Facebook &amp; Instagram ad campaigns that actually convert — no fluff, no wasted budget, just results.
        </p>
        <a
          href="#contact"
          className="inline-block bg-gradient-to-r from-pink-600 to-pink-700 text-white px-10 py-4 rounded-full text-base font-semibold hover:from-pink-700 hover:to-pink-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
        >
          Let's Work Together
        </a>
      </div>
    </section>
  );
}
